export default "__VITE_ASSET__Ck4RN5v2__"